module.exports = new __parcel__URL__("tf_image.0ba9df1a.png").toString();